import { Copyright } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useState } from "react";
import DI from "../../utility/DI";
import { toTitleCase } from "../../utility/tools";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { FetchContext } from "../SideBar";
import SharedExpenses from "../shared_expenses/SharedExpenses";
import { Navigate, useNavigate } from "react-router-dom";
const Dashboard = (props) => {
  const { refresh } = useContext(FetchContext);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [transaction, setTransactions] = React.useState([]);
  const [details, setDetails] = React.useState({
    balance: 0,
    till_date: "",
  });
  const {
    di: { GET, POST, urls, error, success, session },
  } = props;
  const fetchTransactions = async () => {
    setLoading(true);
    await GET(urls.get.get_transactions, {
      user_id: session?.id,
      // approval_status:'true'
    })
      .then((res) => {
        if (res?.success) {
          setTransactions(res.data);
          setDetails({
            balance: res.total_approved_balance,
            till_date: res.till_date,
          });
        } else {
          error(res?.message ?? "error");
        }
        setLoading(false);
      })
      .catch((er) => {
        error("Oops..! session out. Refresh the page");
        setLoading(false);
      });
  };
  React.useEffect(() => {
    fetchTransactions();
  }, [refresh]);

  if (session === undefined || Object.keys(session).length < 1)
    return <Navigate to={'/login'} />

  return (
    <>

      <Grid container spacing={3}>
        {/* Chart */}
        {/* <Grid item xs={12}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 340,
            }}
          >
            <Chart transaction={transaction} formatDate={formatDate} />
          </Paper>
        </Grid> */}
        {/* Recent Deposits */}
        {/* <Grid item xs={12} md={4} lg={3}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 240,
            }}
          >
            <Deposits details={details} />
          </Paper>
        </Grid> */}
        {/* Recent Orders */}
        <Grid item xs={12}>
          <Paper sx={{ p: 0, display: "flex", flexDirection: "column", boxShadow: "none" }}>
            {/* <Orders
              transaction={transaction}
              formatDate={formatDate}
              title="Recent Transactions"
              changestatus={changestatus}
            /> */}
            <SharedExpenses />
          </Paper>
        </Grid>
      </Grid>
      <Copyright sx={{ pt: 4 }} />
    </>
  );
};

export default DI(Dashboard);
